import type { AxiosResponse } from 'axios'

import { FAPI_SEARCH_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from './apiHttpClient'

const apiClient = new HttpClient(environment.shopFAPIUrl)

export interface GetSearchResultPayload {
  query: string
  size: number
  from: number
  searchAll?: boolean
  lang?: string
  category?: string
  sortBy?: string
}

export interface GetSearchSuggestionsPayload {
  query: string
  size: number
  from: number
}

export const searchService = {
  async getSearchResult({
    searchAll = false,
    query = '',
    size = 10,
    from = 0,
    category,
    sortBy,
  }): Promise<AxiosResponse<unknown>> {
    if (searchAll) {
      const endpoint = `${FAPI_SEARCH_ENDPOINT}/searchwithincategories`

      return apiClient.get(endpoint, {
        params: {
          query,
          size,
          from,
          searchProductType: category,
          sortBy,
        },
      })
    }

    return apiClient.get(`${FAPI_SEARCH_ENDPOINT}`, {
      params: {
        query,
        size,
        from,
      },
    })
  },

  async getSearchSuggestions({
    query = '',
    size = 8,
    from = 0,
  }: GetSearchSuggestionsPayload): Promise<AxiosResponse<unknown>> {
    return apiClient.get(`${FAPI_SEARCH_ENDPOINT}/suggestions`, {
      params: {
        query,
        from,
        size,
      },
    })
  },
}
